import React from "react";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";
import { CloseTransferData } from "../types";
import { Stack } from "@origin-digital/ods-core";
import RequestorInfo from "../../RequestorInfo";
import { serviceTypeToStampMsg, handoverTypeToStampMsg } from "../helper";
import { CloseTransferStatusEnum } from "../../types";

export const CloseTransferFormSubmittedServiceSection: React.FC = () => {
  const {
    selectedFormState: { closeTransferPayload },
  } = useCloseTransferFormProps();
  const submittedServices = [
    closeTransferPayload?.ELECTRICITY,
    closeTransferPayload?.GAS,
  ].filter(Boolean) as CloseTransferData[];

  const shouldRender = submittedServices.length > 0;

  if (shouldRender) {
    return (
      <>
        {submittedServices.map((_closeTransferPayload) => (
          <Stack space="xxsmall" key={_closeTransferPayload.service_type}>
            {_closeTransferPayload.close_transfer_status ===
            CloseTransferStatusEnum.NOT_REQUIRED ? (
              <RequestorInfo
                requesterName={_closeTransferPayload?.updater_name || ""}
                submittedDateTime={
                  _closeTransferPayload?.updated
                    ? new Date(_closeTransferPayload.updated)
                    : ""
                }
                behaviourType="submitted"
                actionType={`${
                  serviceTypeToStampMsg[_closeTransferPayload.service_type]
                } ${
                  handoverTypeToStampMsg[_closeTransferPayload.chosen_action]
                }`}
              />
            ) : (
              <RequestorInfo
                requesterName={_closeTransferPayload?.requester_name || ""}
                submittedDateTime={
                  _closeTransferPayload?.submitted
                    ? new Date(_closeTransferPayload.submitted)
                    : ""
                }
                actionType={`${
                  serviceTypeToStampMsg[_closeTransferPayload.service_type]
                } ${
                  handoverTypeToStampMsg[_closeTransferPayload.chosen_action]
                }`}
              />
            )}
          </Stack>
        ))}
      </>
    );
  } else {
    return null;
  }
};
